import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-white overflow-hidden font-poppins">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {/* Left Column: Modern Editorial Text */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-10"
          >
            <div className="space-y-6">
              <div className="inline-flex items-center gap-3">
                <div className="w-10 h-[1px] bg-syana-blue-600"></div>
                <span className="text-[10px] font-black uppercase tracking-[0.4em] text-syana-blue-600">Since 1996</span>
              </div>
              <h2 className="text-4xl lg:text-7xl font-black text-slate-900 leading-[1.1] tracking-tight">
                About <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-syana-blue-600 via-slate-900 to-syana-blue-600 animate-wave-gradient">Siyane Optometrists</span>
              </h2>
            </div>

            <div className="space-y-6 max-w-xl">
              <p className="text-slate-500 text-base lg:text-lg leading-relaxed font-medium">
                The Siyane Optometrists Group has built a reputation as one of the best eye care solution providers in the region by using an innovative approach and state-of-the-art equipment.
              </p>
              <p className="text-slate-500 text-sm lg:text-base leading-relaxed font-medium opacity-80">
                During our nearly 30 years of operations, we have successfully become the first company locally to bring the eye care industry on par with global standards, ensuring world-class care at all branches.
              </p>
            </div>

            <div className="pt-4">
              <button className="group flex items-center gap-4 text-xs font-black uppercase tracking-[0.3em] text-slate-900 hover:text-syana-blue-600 transition-colors">
                Explore Our Story
                <div className="w-8 h-8 rounded-full border border-slate-200 flex items-center justify-center group-hover:border-syana-blue-600 group-hover:bg-syana-blue-600 group-hover:text-white transition-all">
                  <i className="fa-solid fa-arrow-right text-[10px]"></i>
                </div>
              </button>
            </div>
          </motion.div>

          {/* Right Column: Premium Image Card */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="relative"
          >
            <div className="relative h-[500px] lg:h-[650px] rounded-2xl overflow-hidden shadow-2xl shadow-slate-200 group">
              <img 
                src="https://images.unsplash.com/photo-1511174511562-5f7f18b874f8?q=80&w=2070&auto=format&fit=crop" 
                alt="Branding and Vision" 
                className="w-full h-full object-cover grayscale transition-all duration-1000 group-hover:grayscale-0 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/20 to-transparent opacity-60"></div>
              
              {/* Ultra Modern Glass Card */}
              <div className="absolute bottom-8 left-8 right-8 p-10 bg-white/5 backdrop-blur-2xl border border-white/10 rounded-2xl shadow-2xl">
                <span className="inline-block px-3 py-1 bg-syana-blue-600 text-[8px] font-black uppercase tracking-widest text-white rounded-full mb-6">Latest Update</span>
                <h3 className="text-white text-xl lg:text-3xl font-bold mb-4 leading-tight tracking-tight">
                  World Sight Day 2025 Awards
                </h3>
                <p className="text-white/60 text-sm mb-8 font-medium leading-relaxed max-w-md">
                  Empowering communities one step at a time in celebration of vision health locally.
                </p>
                <div className="h-[2px] w-12 bg-syana-blue-600 group-hover:w-full transition-all duration-700"></div>
              </div>
            </div>

            {/* Subtle Brand Initial in Background */}
            <div className="absolute -top-20 -right-20 pointer-events-none opacity-[0.03] select-none text-[30rem] font-black text-slate-900 leading-none -z-10">
              A
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;
